module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_agder_pos.b648e88e.pdf";